import React, { useState } from "react";

const questions = [
  {
    question:
      "What do I do if the hotel says they can’t confirm my booking details?",
    answer:
      "Lorem ipsum dolor sit amet consectetur. Urna id rhoncus morbi egestas. Urna convallis urna amet volutpat dolor vitae aliquam. Velit mattis vitae lobortis mauris nunc tincidunt aenean suspendisse scelerisque. Tristique in urna blandit adipiscing maecenas velit sit scelerisque a.",
  },
  {
    question:
      "What do I do if the hotel says they can’t confirm my booking details?",
    answer:
      "Lorem ipsum dolor sit amet consectetur. Urna id rhoncus morbi egestas. Urna convallis urna amet volutpat dolor vitae aliquam. Velit mattis vitae lobortis mauris nunc tincidunt aenean suspendisse scelerisque. Tristique in urna blandit adipiscing maecenas velit sit scelerisque a.",
  },
  {
    question:
      "What do I do if the hotel says they can’t confirm my booking details?",
    answer:
      "Lorem ipsum dolor sit amet consectetur. Urna id rhoncus morbi egestas. Urna convallis urna amet volutpat dolor vitae aliquam. Velit mattis vitae lobortis mauris nunc tincidunt aenean suspendisse scelerisque. Tristique in urna blandit adipiscing maecenas velit sit scelerisque a.",
  },
  {
    question:
      "What do I do if the hotel says they can’t confirm my booking details?",
    answer:
      "Lorem ipsum dolor sit amet consectetur. Urna id rhoncus morbi egestas. Urna convallis urna amet volutpat dolor vitae aliquam. Velit mattis vitae lobortis mauris nunc tincidunt aenean suspendisse scelerisque. Tristique in urna blandit adipiscing maecenas velit sit scelerisque a.",
  },
  {
    question:
      "What do I do if the hotel says they can’t confirm my booking details?",
    answer:
      "Lorem ipsum dolor sit amet consectetur. Urna id rhoncus morbi egestas. Urna convallis urna amet volutpat dolor vitae aliquam. Velit mattis vitae lobortis mauris nunc tincidunt aenean suspendisse scelerisque. Tristique in urna blandit adipiscing maecenas velit sit scelerisque a.",
  },
];

function HomeFAQSection() {
  const [seleted, setSelected] = useState<number>(0);
  return (
    <div className={Classname.container}>
      <div className={Classname.content}>
        <span className="font-bold text-2xl lg:text-4xl text-center">
          Frequently asked questions
        </span>
        <p className="text-center max-w-4xl mt-2 mb-10 text-sm lg:text-base">
          {`Explore our comprehensive list of frequently asked questions to find answers to common queries. If you can't find the information you're looking for, feel free to reach out to us.`}
        </p>
        <div className="bg-[#F8F9FD] p-3 lg:p-4 w-full flex flex-col rounded-lg mb-20">
          <div className="p-2 bg-white flex flex-col flex-1 rounded-lg gap-4">
            {questions.map((question, index) => (
              <div
                key={index}
                className="bg-[#F8F9FD] w-full rounded-lg p-4 flex cursor-pointer justify-between"
                onClick={() => setSelected(index)}
              >
                <div className="flex flex-col">
                  <span className="text-sm lg:text-base font-semibold">
                    {question.question}
                  </span>
                  {seleted === index && (
                    <p className="mt-4 max-w-4xl opacity-60 text-sm">
                      {question.answer}
                    </p>
                  )}
                </div>
                <div
                  className={`w-8 lg:w-10 h-8 lg:h-10 rounded-lg flex items-center justify-center flex-shrink-0 ml-3 ${
                    seleted === index ? "bg-[#E8EBF3]" : "bg-white"
                  } `}
                >
                  <img
                    src={seleted === index ? "/IconMinus.svg" : "/IconPlus.svg"}
                    alt=""
                    className="w-4 lg:w-5 object-contain"
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default HomeFAQSection;

const Classname = {
  container:
    "w-full flex justify-center pt-20 px-basicx xl:px-0 font-main relative",
  content: "w-full flex flex-col max-w-7xl px-2 xl:px-0 items-center",
  title:
    "text-primary text-lg lg:text-xl font-bold  text-center lg:text-start max-w-56",
  description: "text-sm lg:text-base text-center lg:text-start",
  why: "flex flex-1 flex-col gap-4 items-center lg:items-start",
};
